<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style scoped>
.header-custome{padding-left: 2px;}
</style>
<template>
  <div id="page-attendee-add" class="attendee-form-wrap">
    <div class="header-custome">
      <h3>Add Speaker</h3>
    </div>
    <vx-card v-if="speaker_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs position="left" v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Speaker Information" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <speaker-edit-tab-account :data="speaker_data" />
            </div>
          </vs-tab>
          
          
          <!-- <vs-tab disabled="true" label="Social" icon-pack="feather" icon="icon-share-2">
          </vs-tab>  -->
          
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import speakerEditTabAccount     from './SpeakerEditTabAccount.vue'

// Store Module
import modulespeakerManagementAdd from '@/store/speaker-management/moduleSpeakerManagement.js'

export default {
  components: {
    speakerEditTabAccount
    //attendeeEditTabInformation,
    //attendeeEditTabSocial
  },
  data () {
    return {
      speaker_data: null,
      speaker_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_speaker_data()
    }
  },
  methods: {
    fetch_speaker_data () {
      this.$store.dispatch('speakerManagement/fetchSpeaker', null)
        .then(res => { this.speaker_data = res.data })
        .catch(err => {          
          console.error(err) 
        })
    }
    
  },
  created () {
    // Register Module roundtableManagement Module
    if (!modulespeakerManagementAdd.isRegistered) {
      this.$store.registerModule('speakerManagement', modulespeakerManagementAdd)
      modulespeakerManagementAdd.isRegistered = true
    }    
    this.fetch_speaker_data()
  }
}

</script>